// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Styles for the dropdown menu */
.dropdown-menu .dropdown-item:hover {
  background-color: #0d6efd; /* Change to desired background color */
}
.text-right {
  text-align: right;
}

.avatar-image {
border-radius: 100% !important; 
}

.inputsize{
  width:50%;
}

.search-box {
  width: 50%;
  margin-left: auto;
}


.pagination-wrapper {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;

}

.pagination {
  display: flex;
  list-style: none;
  padding: 0;

}

.pagination li {
  margin: 0 2px;

}

.pagination li a {
  padding: 5px 10px;
  border: 1px solid #ddd;
  color: #007bff;
  text-decoration: none;
  cursor: pointer;

}

.pagination li a:hover {
  background-color: #eee;

}

.pagination li.active a {
  background-color: #2962ff;
  color: white;

  border-color: #2962ff;
}

/* ProjectTables.css */



/* ProjectTables.css */
.search-bar {
  position: relative;
}

.search-bar .form-control {
  padding-right: 30px;
}

.search-bar .search-icon {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  color: #aaa;
}

.pagination-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 20px;

}

.pagination-button {
  background-color: #007bff;
  border: none;
  color: white;

  padding: 10px;
  cursor: pointer;
}

.pagination-info {
  margin: 0 10px;
}



/* ProjectTables.css */

/* Box style for severity data */
.severity-box {
  display: inline-block;
  padding: 5px 10px;
  border-radius: 12px; /* Rounded corners */
  color: #fff; /* Text color */
  font-weight: bold;

}

/* Add specific colors based on severity levels */
.severity-low {
  background-color: #92d051; /* Green for Low severity */
}

.status-fixed {
  background-color: #92d051; /* Green for Low severity */
}

.status-notfixed {
  background-color: #ff0000; /* Green for Low severity */
}
.status-closed {
  background-color: #92d051; /* Green for Low severity */
}

.status-inprogress {
background-color: #fec100; /* Green for Low severity */  
}
.status-won\\'tfix{
background-color: #2962ffdb;
}
.status-new {
  background-color: #2962ffe3; /* Green for Low severity */
}

.severity-medium {
  background-color: #fec100; /* Orange for Medium severity */
}

.severity-high {
  background-color: #ff0000; /* Red for High severity */
}

.severity-critical {
  background-color: #c00000; /* Dark Red for Critical severity */
}
.severity-info {
  background-color:  #52afc7; /* Dark Red for Critical severity */
}

.cvss-score {
  background-color:  #fec100; /* Dark Red for Critical severity */
}

.table-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.export-button {
  margin-left: auto;
}

.table-search {
  display: flex;
  align-items: center;
}

.table-search input {
  margin-right: 0.5rem;
}

.pagination-container {
  position: sticky;
  bottom: 0;
  background: #fff; /* Match the table background */
  z-index: 10;
  padding: 10px 0;
  border-top: 1px solid #ddd; /* Optional for a clean separation */
  display: flex;
  justify-content: center; /* Center pagination */
  width: 100%;
}


.export-container {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
}

.export-button {
  padding: 10px 20px;
  font-size: 16px;
  font-weight: bold;
  color: #fff;
  background-color: #fd7e14;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.export-button:hover {
  background-color: #0056b3;
}

.table-container {
  overflow-x: auto;
}

.table-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  background-color: #2962ff
}

.search-container {
  display: flex;
  align-items: center;
}

.search-container input {
  padding: 5px;
  margin-right: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.cardcolor{background-color: transparent;
border:0;margin-bottom: -0px}

.loader {
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-radius: 50%;
  border-top: 4px solid #3498db;
  width: 30px;
  height: 30px;
  animation: spin 1s linear infinite;
  margin-left: 10px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.notification-alert {
  position: absolute;
    top: 70px;
    left: 370px;
    z-index: 1000;
}

.notification-container {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: 10px;
}

.notification-alert {
  margin-right: 10px; /* Add some space between the alert and the export button */
}
table{font-family:system-ui, sans-serif;}

.card-title{font-family:system-ui, sans-serif;}

.text-center {
  text-align: center;
}

.spinner {
  margin: 20px auto;
  display: block;
}


.mx-4{    margin-right: 0.5rem !important;}

.form-label {
    /*color: #1d9dd9;*/
    font-weight: 600 !important;
    font-family: "Manrope", "Helvetica Neue", helvetica, arial, sans-serif;
  }

.dropdown-menu .show {
  z-index: 1050 !important; /* Ensure it overlays */
    position: fixed !important;
}
.actions-dropdown .dropdown .show{
  z-index: 1050 !important; 
    position: fixed !important;
  }


/*.actions-dropdown .dropdown-menu.show {
    z-index: 1050 !important; 
    position: absolute !important; 
    transform: none !important; 
    top: auto !important;
    left: auto !important;
    bottom: auto !important;
    right: auto !important;
}*/

/*

.detection-badge {
  display: inline-block;
  padding: 0.25em 0.75em;
  border-radius: 0.5em;
  font-size: 0.85em;
  margin-right: 0.5em;
  font-weight: bold;
}

.badge-high {
  background-color: #f8d7da;
  color: #dc3545;
  border: 1px solid #dc3545;
}

.badge-medium {
  background-color: #fff3cd;
  color: #856404;
  border: 1px solid #856404;
}

.badge-low {
  background-color: #d4edda;
  color: #28a745;
  border: 1px solid #28a745;
}
*/


/* Add specificity to ensure your styles take effect */
table .detection-badge {
  display: inline-block;
  padding: 0.15em 0.5em;  /* Reduce padding for smaller boxes */
  border-radius: 0.5em;
  font-size: 0.80em;  /* Smaller font size */
  line-height: 1.2;  /* Adjust line height to make text compact */
  margin-right: 0.5em;
  font-weight: bold;
  white-space: normal; /* Allow text to wrap to multiple lines */
}

table .badge-high {
  background-color: #f8d7da;
  color: #dc3545;
  border: 1px solid #dc3545;
}

table .badge-medium {
  background-color: #fff3cd;
  color: #856404;
  border: 1px solid #856404;
}

table .badge-low {
  background-color: #d4edda;
  color: #28a745;
  border: 1px solid #28a745;
}


.device-badge {
  display: inline-block;
  padding: 0.25em 0.75em;
  border-radius: 0.5em;
  font-size: 0.80em;
  margin-right: 0.5em;
  font-weight: bold;
  background-color: #e2e3e5; /* Light gray background for device info */
  border: 1px solid #ced4da; /* Gray border */
  color: #495057; /* Text color */
}





.pagination {
  display: flex;
  list-style: none;
  padding: 0;
}

.page-item {
  margin: 0 5px;
}

.page-link {
  padding: 5px 10px;
  border: 1px solid #ddd;
  color: #007bff;
  cursor: pointer;
  text-decoration: none;
}

.page-item.active .page-link {
  background-color: #2962ff;
  color: white;
  border-color: #2962ff;
}

.page-link:hover {
  background-color: #eee;
}





/*** package select option css */


/* Custom select and options styles for a professional look */
.custom-select {
  font-weight: bold;
  font-size: 16px;
  background-color: #f0f0f0;
  color: #333;
  border: 1px solid #ccc;
  padding: 8px 12px;
  border-radius: 5px;
  font-family: 'Arial', sans-serif;
  transition: border-color 0.3s ease-in-out;
}

.custom-select:hover,
.custom-select:focus {
  border-color: #007bff;
  outline: none;
}

.custom-option {
  font-size: 16px;
  font-weight: normal;
  padding: 10px 15px;
  background-color: #fff;
  color: #333;
  font-family: 'Arial', sans-serif;
}

.custom-option:hover {
  background-color: #007bff;
  color: #fff;
}
`, "",{"version":3,"sources":["webpack://./src/components/ecommerce/LatestOrders.css"],"names":[],"mappings":"AAAA,iCAAiC;AACjC;EACE,yBAAyB,EAAE,uCAAuC;AACpE;AACA;EACE,iBAAiB;AACnB;;AAEA;AACA,8BAA8B;AAC9B;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,UAAU;EACV,iBAAiB;AACnB;;;AAGA;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;;AAElB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,UAAU;;AAEZ;;AAEA;EACE,aAAa;;AAEf;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;EACd,qBAAqB;EACrB,eAAe;;AAEjB;;AAEA;EACE,sBAAsB;;AAExB;;AAEA;EACE,yBAAyB;EACzB,YAAY;;EAEZ,qBAAqB;AACvB;;AAEA,sBAAsB;;;;AAItB,sBAAsB;AACtB;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;;AAElB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;;EAEZ,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;;;AAIA,sBAAsB;;AAEtB,gCAAgC;AAChC;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB,EAAE,oBAAoB;EACzC,WAAW,EAAE,eAAe;EAC5B,iBAAiB;;AAEnB;;AAEA,iDAAiD;AACjD;EACE,yBAAyB,EAAE,2BAA2B;AACxD;;AAEA;EACE,yBAAyB,EAAE,2BAA2B;AACxD;;AAEA;EACE,yBAAyB,EAAE,2BAA2B;AACxD;AACA;EACE,yBAAyB,EAAE,2BAA2B;AACxD;;AAEA;AACA,yBAAyB,EAAE,2BAA2B;AACtD;AACA;AACA,2BAA2B;AAC3B;AACA;EACE,2BAA2B,EAAE,2BAA2B;AAC1D;;AAEA;EACE,yBAAyB,EAAE,+BAA+B;AAC5D;;AAEA;EACE,yBAAyB,EAAE,0BAA0B;AACvD;;AAEA;EACE,yBAAyB,EAAE,mCAAmC;AAChE;AACA;EACE,0BAA0B,EAAE,mCAAmC;AACjE;;AAEA;EACE,0BAA0B,EAAE,mCAAmC;AACjE;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,gBAAgB,EAAE,+BAA+B;EACjD,WAAW;EACX,eAAe;EACf,0BAA0B,EAAE,oCAAoC;EAChE,aAAa;EACb,uBAAuB,EAAE,sBAAsB;EAC/C,WAAW;AACb;;;AAGA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA,WAAW,6BAA6B;AACxC,QAAQ,CAAC,mBAAmB;;AAE5B;EACE,oCAAoC;EACpC,kBAAkB;EAClB,6BAA6B;EAC7B,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,kBAAkB;IAChB,SAAS;IACT,WAAW;IACX,aAAa;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB,EAAE,2DAA2D;AACjF;AACA,MAAM,iCAAiC,CAAC;;AAExC,YAAY,iCAAiC,CAAC;;AAE9C;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;;AAGA,UAAU,+BAA+B,CAAC;;AAE1C;IACI,kBAAkB;IAClB,2BAA2B;IAC3B,sEAAsE;EACxE;;AAEF;EACE,wBAAwB,EAAE,uBAAuB;IAC/C,0BAA0B;AAC9B;AACA;EACE,wBAAwB;IACtB,0BAA0B;EAC5B;;;AAGF;;;;;;;;EAQE;;AAEF;;;;;;;;;;;;;;;;;;;;;;;;;;;;CA4BC;;;AAGD,sDAAsD;AACtD;EACE,qBAAqB;EACrB,qBAAqB,GAAG,qCAAqC;EAC7D,oBAAoB;EACpB,iBAAiB,GAAG,sBAAsB;EAC1C,gBAAgB,GAAG,4CAA4C;EAC/D,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB,EAAE,yCAAyC;AAChE;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;;AAGA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,oBAAoB;EACpB,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB,EAAE,0CAA0C;EACrE,yBAAyB,EAAE,gBAAgB;EAC3C,cAAc,EAAE,eAAe;AACjC;;;;;;AAMA;EACE,aAAa;EACb,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;;;;;AAMA,gCAAgC;;;AAGhC,6DAA6D;AAC7D;EACE,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,WAAW;EACX,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,gCAAgC;EAChC,yCAAyC;AAC3C;;AAEA;;EAEE,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb","sourcesContent":["/* Styles for the dropdown menu */\n.dropdown-menu .dropdown-item:hover {\n  background-color: #0d6efd; /* Change to desired background color */\n}\n.text-right {\n  text-align: right;\n}\n\n.avatar-image {\nborder-radius: 100% !important; \n}\n\n.inputsize{\n  width:50%;\n}\n\n.search-box {\n  width: 50%;\n  margin-left: auto;\n}\n\n\n.pagination-wrapper {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 10px;\n\n}\n\n.pagination {\n  display: flex;\n  list-style: none;\n  padding: 0;\n\n}\n\n.pagination li {\n  margin: 0 2px;\n\n}\n\n.pagination li a {\n  padding: 5px 10px;\n  border: 1px solid #ddd;\n  color: #007bff;\n  text-decoration: none;\n  cursor: pointer;\n\n}\n\n.pagination li a:hover {\n  background-color: #eee;\n\n}\n\n.pagination li.active a {\n  background-color: #2962ff;\n  color: white;\n\n  border-color: #2962ff;\n}\n\n/* ProjectTables.css */\n\n\n\n/* ProjectTables.css */\n.search-bar {\n  position: relative;\n}\n\n.search-bar .form-control {\n  padding-right: 30px;\n}\n\n.search-bar .search-icon {\n  position: absolute;\n  right: 10px;\n  top: 50%;\n  transform: translateY(-50%);\n  pointer-events: none;\n  color: #aaa;\n}\n\n.pagination-wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-top: 20px;\n\n}\n\n.pagination-button {\n  background-color: #007bff;\n  border: none;\n  color: white;\n\n  padding: 10px;\n  cursor: pointer;\n}\n\n.pagination-info {\n  margin: 0 10px;\n}\n\n\n\n/* ProjectTables.css */\n\n/* Box style for severity data */\n.severity-box {\n  display: inline-block;\n  padding: 5px 10px;\n  border-radius: 12px; /* Rounded corners */\n  color: #fff; /* Text color */\n  font-weight: bold;\n\n}\n\n/* Add specific colors based on severity levels */\n.severity-low {\n  background-color: #92d051; /* Green for Low severity */\n}\n\n.status-fixed {\n  background-color: #92d051; /* Green for Low severity */\n}\n\n.status-notfixed {\n  background-color: #ff0000; /* Green for Low severity */\n}\n.status-closed {\n  background-color: #92d051; /* Green for Low severity */\n}\n\n.status-inprogress {\nbackground-color: #fec100; /* Green for Low severity */  \n}\n.status-won\\'tfix{\nbackground-color: #2962ffdb;\n}\n.status-new {\n  background-color: #2962ffe3; /* Green for Low severity */\n}\n\n.severity-medium {\n  background-color: #fec100; /* Orange for Medium severity */\n}\n\n.severity-high {\n  background-color: #ff0000; /* Red for High severity */\n}\n\n.severity-critical {\n  background-color: #c00000; /* Dark Red for Critical severity */\n}\n.severity-info {\n  background-color:  #52afc7; /* Dark Red for Critical severity */\n}\n\n.cvss-score {\n  background-color:  #fec100; /* Dark Red for Critical severity */\n}\n\n.table-toolbar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1rem;\n}\n\n.export-button {\n  margin-left: auto;\n}\n\n.table-search {\n  display: flex;\n  align-items: center;\n}\n\n.table-search input {\n  margin-right: 0.5rem;\n}\n\n.pagination-container {\n  position: sticky;\n  bottom: 0;\n  background: #fff; /* Match the table background */\n  z-index: 10;\n  padding: 10px 0;\n  border-top: 1px solid #ddd; /* Optional for a clean separation */\n  display: flex;\n  justify-content: center; /* Center pagination */\n  width: 100%;\n}\n\n\n.export-container {\n  display: flex;\n  justify-content: flex-end;\n  margin-bottom: 10px;\n}\n\n.export-button {\n  padding: 10px 20px;\n  font-size: 16px;\n  font-weight: bold;\n  color: #fff;\n  background-color: #fd7e14;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n}\n\n.export-button:hover {\n  background-color: #0056b3;\n}\n\n.table-container {\n  overflow-x: auto;\n}\n\n.table-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 10px;\n  background-color: #2962ff\n}\n\n.search-container {\n  display: flex;\n  align-items: center;\n}\n\n.search-container input {\n  padding: 5px;\n  margin-right: 10px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\n\n.cardcolor{background-color: transparent;\nborder:0;margin-bottom: -0px}\n\n.loader {\n  border: 4px solid rgba(0, 0, 0, 0.1);\n  border-radius: 50%;\n  border-top: 4px solid #3498db;\n  width: 30px;\n  height: 30px;\n  animation: spin 1s linear infinite;\n  margin-left: 10px;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.notification-alert {\n  position: absolute;\n    top: 70px;\n    left: 370px;\n    z-index: 1000;\n}\n\n.notification-container {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  margin-bottom: 10px;\n}\n\n.notification-alert {\n  margin-right: 10px; /* Add some space between the alert and the export button */\n}\ntable{font-family:system-ui, sans-serif;}\n\n.card-title{font-family:system-ui, sans-serif;}\n\n.text-center {\n  text-align: center;\n}\n\n.spinner {\n  margin: 20px auto;\n  display: block;\n}\n\n\n.mx-4{    margin-right: 0.5rem !important;}\n\n.form-label {\n    /*color: #1d9dd9;*/\n    font-weight: 600 !important;\n    font-family: \"Manrope\", \"Helvetica Neue\", helvetica, arial, sans-serif;\n  }\n\n.dropdown-menu .show {\n  z-index: 1050 !important; /* Ensure it overlays */\n    position: fixed !important;\n}\n.actions-dropdown .dropdown .show{\n  z-index: 1050 !important; \n    position: fixed !important;\n  }\n\n\n/*.actions-dropdown .dropdown-menu.show {\n    z-index: 1050 !important; \n    position: absolute !important; \n    transform: none !important; \n    top: auto !important;\n    left: auto !important;\n    bottom: auto !important;\n    right: auto !important;\n}*/\n\n/*\n\n.detection-badge {\n  display: inline-block;\n  padding: 0.25em 0.75em;\n  border-radius: 0.5em;\n  font-size: 0.85em;\n  margin-right: 0.5em;\n  font-weight: bold;\n}\n\n.badge-high {\n  background-color: #f8d7da;\n  color: #dc3545;\n  border: 1px solid #dc3545;\n}\n\n.badge-medium {\n  background-color: #fff3cd;\n  color: #856404;\n  border: 1px solid #856404;\n}\n\n.badge-low {\n  background-color: #d4edda;\n  color: #28a745;\n  border: 1px solid #28a745;\n}\n*/\n\n\n/* Add specificity to ensure your styles take effect */\ntable .detection-badge {\n  display: inline-block;\n  padding: 0.15em 0.5em;  /* Reduce padding for smaller boxes */\n  border-radius: 0.5em;\n  font-size: 0.80em;  /* Smaller font size */\n  line-height: 1.2;  /* Adjust line height to make text compact */\n  margin-right: 0.5em;\n  font-weight: bold;\n  white-space: normal; /* Allow text to wrap to multiple lines */\n}\n\ntable .badge-high {\n  background-color: #f8d7da;\n  color: #dc3545;\n  border: 1px solid #dc3545;\n}\n\ntable .badge-medium {\n  background-color: #fff3cd;\n  color: #856404;\n  border: 1px solid #856404;\n}\n\ntable .badge-low {\n  background-color: #d4edda;\n  color: #28a745;\n  border: 1px solid #28a745;\n}\n\n\n.device-badge {\n  display: inline-block;\n  padding: 0.25em 0.75em;\n  border-radius: 0.5em;\n  font-size: 0.80em;\n  margin-right: 0.5em;\n  font-weight: bold;\n  background-color: #e2e3e5; /* Light gray background for device info */\n  border: 1px solid #ced4da; /* Gray border */\n  color: #495057; /* Text color */\n}\n\n\n\n\n\n.pagination {\n  display: flex;\n  list-style: none;\n  padding: 0;\n}\n\n.page-item {\n  margin: 0 5px;\n}\n\n.page-link {\n  padding: 5px 10px;\n  border: 1px solid #ddd;\n  color: #007bff;\n  cursor: pointer;\n  text-decoration: none;\n}\n\n.page-item.active .page-link {\n  background-color: #2962ff;\n  color: white;\n  border-color: #2962ff;\n}\n\n.page-link:hover {\n  background-color: #eee;\n}\n\n\n\n\n\n/*** package select option css */\n\n\n/* Custom select and options styles for a professional look */\n.custom-select {\n  font-weight: bold;\n  font-size: 16px;\n  background-color: #f0f0f0;\n  color: #333;\n  border: 1px solid #ccc;\n  padding: 8px 12px;\n  border-radius: 5px;\n  font-family: 'Arial', sans-serif;\n  transition: border-color 0.3s ease-in-out;\n}\n\n.custom-select:hover,\n.custom-select:focus {\n  border-color: #007bff;\n  outline: none;\n}\n\n.custom-option {\n  font-size: 16px;\n  font-weight: normal;\n  padding: 10px 15px;\n  background-color: #fff;\n  color: #333;\n  font-family: 'Arial', sans-serif;\n}\n\n.custom-option:hover {\n  background-color: #007bff;\n  color: #fff;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
